"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const number_1 = require("../util/number");
const tx_1 = require("../util/tx");
const constant_1 = require("../constant");
class GasFee {
    constructor(txGasCosts, txGasPrices) {
        this.txGasCosts = txGasCosts;
        this.txGasPrices = txGasPrices;
    }
    static instance(txGasCosts = {}, txGasPrices = {}) {
        return new GasFee(txGasCosts, txGasPrices);
    }
    getFee(msgTypeUrl, denom = constant_1.DEFAULT_FEE_DENOM) {
        const minGasPrice = this.getGasPrice(denom);
        const msgGasCost = this.getGasCost(msgTypeUrl);
        return msgGasCost.times(minGasPrice);
    }
    getGasPrice(denom) {
        var _a;
        if (!this.txGasPrices) {
            console.warn("tx gas prices not initialized");
        }
        const gasPrice = (_a = this.txGasPrices) === null || _a === void 0 ? void 0 : _a[denom];
        if (!gasPrice) {
            console.warn("denom not supported for paying gas");
        }
        return gasPrice !== null && gasPrice !== void 0 ? gasPrice : number_1.BN_ZERO;
    }
    getGasCost(msgTypeUrl) {
        var _a, _b, _c, _d;
        if (!this.txGasCosts) {
            console.warn("tx gas costs not initialized");
        }
        return (_d = (_b = (_a = this.txGasCosts) === null || _a === void 0 ? void 0 : _a[msgTypeUrl]) !== null && _b !== void 0 ? _b : (_c = this.txGasCosts) === null || _c === void 0 ? void 0 : _c[tx_1.TxGasCostTypeDefaultKey]) !== null && _d !== void 0 ? _d : number_1.BN_ZERO;
    }
}
exports.default = GasFee;
